<generic-list-manager
    [config]="genericListConfig"
    [skipReloadConfirm]="true"
></generic-list-manager>
